import HomeIcon from '@material-ui/icons/HomeOutlined';
import ShipmentIcon from '@material-ui/icons/LocalShippingOutlined';
import InvoicesIcon from '@material-ui/icons/AttachMoneyOutlined';
import QuickRateIcon from '@material-ui/icons/DoneAllOutlined';
import ReportsIcon from '@material-ui/icons/BarChartOutlined';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import SettingsIcon from '@material-ui/icons/Settings';
import BuildIcon from '@material-ui/icons/Build';
import _get from 'lodash/get';

import { ADMIN, SHIPPER, QUOTER } from '../../constants/permissions';
import { IS_PROPEL_ADMINISTRATOR_KEY } from '../../constants/constants';

const t = text => text;

export const primaryLinks = [
  {
    name: t('Admin'),
    icon: BuildIcon,
    groupId: 'admin',
    requiresOrg: false,
    isPermitted: globalProps => {
      return _get(globalProps, IS_PROPEL_ADMINISTRATOR_KEY, false);
    }
  },
  {
    name: t('Organizations'),
    path: '/admin/organizations',
    parent: 'admin',
    requiresOrg: false,
    isPermitted: globalProps => {
      return _get(globalProps, IS_PROPEL_ADMINISTRATOR_KEY, false);
    }
  },
  {
    name: t('Dashboard'),
    path: '/dashboard',
    icon: HomeIcon
  },
  {
    name: t('Shipments'),
    path: '/shipments',
    icon: ShipmentIcon,
    isPermitted: (globalProps, isPermissible) => {
      return (
        isPermissible(globalProps, ADMIN, true) ||
        isPermissible(globalProps, SHIPPER, true) ||
        isPermissible(globalProps, QUOTER, true)
      );
    }
  },
  {
    name: t('Quick Rate'),
    path: '/quick-rate',
    icon: QuickRateIcon,
    isPermitted: (globalProps, isPermissible) => {
      return (
        isPermissible(globalProps, ADMIN, true) ||
        isPermissible(globalProps, SHIPPER, true) ||
        isPermissible(globalProps, QUOTER, true)
      );
    }
  },
  {
    name: t('Invoices'),
    path: '/invoices',
    icon: InvoicesIcon,
    isPermitted: (globalProps, _isPermissible) => {
      // TODO: Limiting invoices to Propel Admin while in dev. Remove this and uncomment below when ready.
      return _get(globalProps, IS_PROPEL_ADMINISTRATOR_KEY, false);
      // return (
      //   isPermissible(globalProps, ADMIN, true) ||
      //   isPermissible(globalProps, SHIPPER, true)
      // );
    }
  },
  {
    name: t('Reports'),
    path: '/reports',
    icon: ReportsIcon
  },
  {
    name: t('My Organization'),
    icon: LocationCityIcon,
    groupId: 'myOrganization',
    isPermitted: (globalProps, isPermissible) => {
      return isPermissible(globalProps, ADMIN, true);
    }
  },
  {
    name: t('Locations'),
    path: '/locations',
    parent: 'myOrganization'
  },
  {
    name: t('Products'),
    path: '/products',
    parent: 'myOrganization'
  },
  {
    name: t('Carrier Relationships'),
    path: '/carrier-relationships',
    parent: 'myOrganization'
  },
  {
    name: t('Accessorials'),
    path: '/accessorials',
    parent: 'myOrganization'
  },
  {
    name: t('GL Codes'),
    path: '/gl-codes',
    parent: 'myOrganization'
  },
  {
    name: t('LCP Exception Reasons'),
    path: '/lcp-exception-reasons',
    parent: 'myOrganization'
  },
  {
    name: t('Cancellation Reasons'),
    path: '/cancellation-reasons',
    parent: 'myOrganization'
  },
  {
    name: t('Contacts'),
    path: '/contacts',
    parent: 'myOrganization'
  },
  {
    name: t('System Settings'),
    icon: SettingsIcon,
    groupId: 'settings',
    isPermitted: (globalProps, isPermissible) => {
      return isPermissible(globalProps, ADMIN, true);
    }
  },
  {
    name: t('General'),
    path: '/general',
    parent: 'settings'
  },

  {
    name: t('Custom Fields'),
    path: '/custom-fields',
    parent: 'settings'
  },

  {
    name: t('Saved Views'),
    path: '/saved-views',
    parent: 'settings'
  },
  {
    name: t('Users & Security'),
    path: '/users',
    parent: 'settings'
  }
];
